/**
 * Component: ProductInfoVideo
 */
import Modal from './Modal';

export default class ProductInfoVideo {
    constructor(id) {
        this.$self = jQuery('#' + id);
        this.$modalContent = this.$self.find('.modal__content');
        this.embedCode = this.$self.data('embedCode');
        if (this.embedCode) {
            this.embedElement = jQuery.parseHTML(this.embedCode);
        }

        this.modalOpenCallback = this.modalOpenCallback.bind(this);
        this.modalCloseCallback = this.modalCloseCallback.bind(this);

        this.init();
    }

    init() {
        var config = {
            openCallback: this.modalOpenCallback,
            closeCallback: this.modalCloseCallback,
            showCloseButton: true
        };

        this.modal = new Modal('info-video-modal', config); // eslint-disable-line no-new
    }

    modalOpenCallback() {
        if (this.embedElement) {
            this.$modalContent.empty();
            $(this.embedElement).hide().appendTo(this.$modalContent).fadeIn();
        }
    }

    modalCloseCallback() {
        this.$modalContent.html('<div class="product-info-video__error-message"><h3>There was a problem loading the video</h3></div>');
    }
}
